import CamelCaseString from "../../Common/CamelCaseString";
import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const getAthleteData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ATHLETE_LOADING,
    payload: {
      pageLoading: true,
      buttonLoading: false,
    },
  });
  userService
    .getAthleteDetails(payload.id)
    .then((res) => {
      const { uploadedLogo, groupAthletes } = res.data.data;
      const newGroupResponse = groupAthletes?.map(
        ({ name: groupName, ...rest }) => ({
          groupName,
          ...rest,
        })
      );
      dispatch({
        type: ActionTypes.GET_ATHLETE_DATA,
        payload: res.data.data,
      });
      dispatch({
        type: ActionTypes.HANDLE_ATHLETE_LOGO_UPLOAD,
        payload: { filePath: uploadedLogo?.filePath, id: uploadedLogo?.id },
      });
      dispatch({
        type: ActionTypes.SET_SELECTED_GROUPS_LIST,
        payload: newGroupResponse ? newGroupResponse : [],
      });
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const handleAthleteLogoUpload = (dispatch, payload) => {
  const data = new FormData();
  data.append("file", payload.file);
  data.append("userId", payload.currentUserId);
  dispatch({
    type: ActionTypes.ATHLETE_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      profileImageLoading: true,
    },
  });
  userService
    .postLogoForAll(data)
    .then((res) => {
      const { filePath, id } = res.data.data;
      dispatch({
        type: ActionTypes.HANDLE_ATHLETE_LOGO_UPLOAD,
        payload: { filePath, id },
      });
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          profileImageLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          profileImageLoading: false,
        },
      });
    });
};

export const deleteAthlete = (dispatch, payload) => {
  userService
    .deleteAtheleteById({ ids: [payload.id] })
    .then(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.DELETE_ATHLETE,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Athlete Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
    });
};

export const activateInactivateAthlete = (dispatch, payload) => {
  userService
    .changeAthleteStatus(payload.id, payload.status)
    .then((response) => {
      if (response.data.success == true) {
        dispatch({
          type: ActionTypes.ACTIVATE_INACTIVATE_ATHLETE,
          payload: payload.status,
        });
        dispatch({
          type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
          payload: false,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: `Athlete ${
                payload.status ? "Activated" : "Deactivated"
              } Successfully.`,
              open: true,
            },
          },
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
    });
};

export const editAthlete = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ATHLETE_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .editAthleteDetails(
      payload.firstName,
      payload.lastName,
      payload.email,
      payload.phoneNumber,
      payload.positionPlayed,
      payload.graduationYear,
      payload.profileImageId,
      payload.id,
      payload.jerseyNumber,
      payload.schoolId,
      payload.groupIds,
      payload.instaUrl,
      payload.twitterUrl
    )
    .then(() => {
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: `Athlete Updated Successfully.`,
            open: true,
            navigationLink: `/athletedetails/${payload.id}`,
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
    });
};

export const addAthlete = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.ATHLETE_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .AddAthleteDetails(
      payload.firstName,
      payload.lastName,
      payload.email,
      payload.phoneNumber,
      payload.jerseyNumber,
      payload.positionPlayed,
      payload.group,
      payload.profileImageId,
      payload.graduationYear,
      payload.schoolId,
      payload.groupIds,
      payload.teamIds,
      payload.instaUrl,
      payload.twitterUrl,
      payload.sportsIds
    )
    .then((res) => {
      if (res.status == 200 && res.data.status === true) {
        const memberId = res.data.data.id;
        const type = "MEMBER_ADDED";
        const isOnPage = "true";
        const pageName = "CELL";
        userService.addActivityMemberAdded(
          memberId,
          payload.schoolId,
          payload.currentUserId,
          isOnPage,
          pageName,
          type,
          payload.profileImageId
        );
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: `Athlete Added Successfully.`,
              open: true,
              navigationLink: "/schoolathletes",
            },
          },
        });
      } else {
        dispatch({
          type: ActionTypes.OPEN_FAIL_DIALOG,
          payload: {
            open: true,
            message: CamelCaseString(res.data?.message),
          },
        });
      }
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.ATHLETE_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong.",
        },
      });
    });
};

export const setAthleteGraduationYear = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_ATHLETE_GRADUATION_YEAR,
    payload: payload,
  });
};

export const resetAthleteData = (dispatch) => {
  dispatch({
    type: ActionTypes.RESET_ATHLETE_DATA,
    payload: null,
  });
};
